import React from "react";
import { NeoButton, NeoInput } from "../../../../../components/Common";
import { WOD_UNITS } from "../../domain/wod/constants";
import { WOD_MOVEMENT_LIBRARY } from "../../domain/wod/movementLibrary";

const WodMovementRow = ({ baseName, setIndex, set, handleChange, onRemove }) => {
    const handleMovementInput = (event) => {
        const typedValue = event.target.value;
        // Update the movement name immediately (free text)
        handleChange({ target: { name: `${baseName}.${setIndex}.movement`, value: typedValue } });

        // Try to match against library to auto-fill category/unit
        const match = WOD_MOVEMENT_LIBRARY.find(m => m.name === typedValue);
        if (match) {
            handleChange({ target: { name: `${baseName}.${setIndex}.movementId`, value: match.id } });
            handleChange({ target: { name: `${baseName}.${setIndex}.category`, value: match.category } });
            handleChange({ target: { name: `${baseName}.${setIndex}.unit`, value: match.defaultUnit || "reps" } });
        } else {
            handleChange({ target: { name: `${baseName}.${setIndex}.movementId`, value: "" } });
        }
    };

    return (
        <div className="wod-movement-row hover-shadow">
            <div className="row g-2 align-items-end">
                <div className="col-lg-3 col-md-6 col-12">
                    <label className="font-size-10 mb-1 text-muted fw-bold text-uppercase">Movimento</label>
                    <NeoInput
                        type="text"
                        list={`wod-movements-${setIndex}`}
                        name={`${baseName}.${setIndex}.movement`}
                        value={set.movement || ""}
                        onChange={handleMovementInput}
                        size="sm"
                        placeholder="Selecione ou digite..."
                    />
                    <datalist id={`wod-movements-${setIndex}`}>
                        {WOD_MOVEMENT_LIBRARY.map(movement => (
                            <option key={movement.id} value={movement.name} />
                        ))}
                    </datalist>
                </div>
                <div className="col-lg-1 col-md-2 col-4">
                    <label className="font-size-10 mb-1 text-muted fw-bold text-uppercase">Qtd.</label>
                    <NeoInput type="text" name={`${baseName}.${setIndex}.reps`} value={set.reps || ""} onChange={handleChange} size="sm" placeholder="21" />
                </div>
                <div className="col-lg-1 col-md-2 col-4">
                    <label className="font-size-10 mb-1 text-muted fw-bold text-uppercase">Unid.</label>
                    <NeoInput type="select" name={`${baseName}.${setIndex}.unit`} value={set.unit || "reps"} onChange={handleChange} size="sm">
                        {WOD_UNITS.map(unit => <option key={unit.value} value={unit.value}>{unit.label}</option>)}
                    </NeoInput>
                </div>
                <div className="col-lg-2 col-md-2 col-4">
                    <label className="font-size-10 mb-1 text-muted fw-bold text-uppercase">Carga</label>
                    <NeoInput type="text" name={`${baseName}.${setIndex}.load`} value={set.load || ""} onChange={handleChange} size="sm" placeholder="95/65 lb" />
                </div>
                <div className="col-lg-2 col-md-4 col-6">
                    <label className="font-size-10 mb-1 text-muted fw-bold text-uppercase">Tempo/Minuto</label>
                    <NeoInput type="text" name={`${baseName}.${setIndex}.time`} value={set.time || ""} onChange={handleChange} size="sm" placeholder="Min 1 / 40s" />
                </div>
                <div className="col-lg-2 col-md-6 col-6">
                    <label className="font-size-10 mb-1 text-muted fw-bold text-uppercase">Obs.</label>
                    <NeoInput type="text" name={`${baseName}.${setIndex}.notes`} value={set.notes || set.description || ""} onChange={handleChange} size="sm" placeholder="padrão, alvo, variação" />
                </div>
                <div className="col-lg-1 col-md-2 col-12 d-flex justify-content-end">
                    <NeoButton type="button" variant="soft-danger" size="sm" square icon="mdi-delete-outline" onClick={onRemove} className="w-100 wod-btn-delete" />
                </div>
            </div>
            <div className="row g-2 mt-1">
                <div className="col-md-4 col-12">
                    <NeoInput type="text" name={`${baseName}.${setIndex}.scaling.rx`} value={set.scaling?.rx || ""} onChange={handleChange} size="sm" placeholder="RX" />
                </div>
                <div className="col-md-4 col-12">
                    <NeoInput type="text" name={`${baseName}.${setIndex}.scaling.intermediate`} value={set.scaling?.intermediate || ""} onChange={handleChange} size="sm" placeholder="Intermediário" />
                </div>
                <div className="col-md-4 col-12">
                    <NeoInput type="text" name={`${baseName}.${setIndex}.scaling.beginner`} value={set.scaling?.beginner || ""} onChange={handleChange} size="sm" placeholder="Iniciante" />
                </div>
            </div>
        </div>
    );
};

export default WodMovementRow;
